import { Camera, HardHat, MoreHorizontal, TriangleAlert } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/cn';

/**
 * Navegación de campo: 4 destinos, iconos grandes, 56 px de alto.
 *
 * NO es una versión reducida del menú de escritorio. Es lo que necesita un
 * encargado a pie de obra: sus obras, subir una foto, abrir una incidencia.
 * El resto vive detrás de "Más" porque no se usa con casco puesto.
 */
const ITEMS = [
  { to: '/obras', label: 'Obras', icon: HardHat },
  { to: '/fotos', label: 'Fotos', icon: Camera },
  { to: '/incidencias', label: 'Incidencias', icon: TriangleAlert },
];

export function MobileNav({ onMas }: { onMas: () => void }) {
  return (
    <nav
      data-tour="navegacion-movil"
      className="flex h-14 shrink-0 items-stretch border-t border-border bg-surface md:hidden"
      aria-label="Navegación principal"
    >
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            cn(
              'flex flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-medium transition-colors',
              isActive ? 'text-brand' : 'text-fg-muted',
            )
          }
        >
          <item.icon className="size-5" />
          {item.label}
        </NavLink>
      ))}
      {/* «Más» abre el menú completo. Antes llevaba a /mas, una pantalla
          «pendiente» sin nada dentro: el resto de la aplicación quedaba
          inalcanzable desde el móvil. */}
      <button
        type="button"
        onClick={onMas}
        className="flex flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-medium text-fg-muted transition-colors"
      >
        <MoreHorizontal className="size-5" />
        Más
      </button>
    </nav>
  );
}
